var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProLevelOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_347_7336",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 224,
    height: 224
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 112,
    fill: "#EDF4F8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_347_7336)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 112,
    fill: "#EDF4F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_347_7336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 71.8621L112 56L180 71.8621V208.276L112 240L44 208.276V71.8621Z",
    fill: "url(#paint0_linear_347_7336)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.1163 205.654V75.1287L112 60.2268L175.884 75.1287V205.654L112 235.458L48.1163 205.654Z",
    stroke: "url(#paint1_linear_347_7336)",
    strokeWidth: 8.23253
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1761 207.527V72.7954L112 57.2076L178.824 72.7954V207.527L112 238.702L45.1761 207.527Z",
    stroke: "url(#paint2_linear_347_7336)",
    strokeOpacity: 0.2,
    strokeWidth: 2.35215
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.266 204.051V208.277H100.139V189.242H104.856V204.051H117.269H117.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.636 189.242V194.506H111.904V189.242H107.187V201.704H111.904V198.76H119.636V208.277H124.323V189.242H119.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.152 144.278C93.2133 144.278 92.3973 144.123 91.704 143.814C91.0107 143.494 90.472 143.051 90.088 142.486C89.7147 141.92 89.5227 141.259 89.512 140.502L91.864 140.534C91.9067 141.078 92.1307 141.52 92.536 141.862C92.952 142.203 93.5013 142.374 94.184 142.374C94.7387 142.374 95.1973 142.262 95.56 142.038C95.9227 141.803 96.104 141.462 96.104 141.014C96.104 140.779 96.0453 140.587 95.928 140.438C95.8213 140.278 95.6507 140.15 95.416 140.054C95.1813 139.947 94.888 139.856 94.536 139.782C94.1947 139.696 93.7893 139.606 93.32 139.51C92.8507 139.424 92.4027 139.312 91.976 139.174C91.5493 139.035 91.1707 138.848 90.84 138.614C90.5093 138.379 90.248 138.075 90.056 137.702C89.864 137.328 89.768 136.854 89.768 136.278C89.768 135.606 89.9387 135.019 90.28 134.518C90.6213 134.016 91.1067 133.622 91.736 133.334C92.3653 133.035 93.1013 132.886 93.944 132.886C94.8293 132.886 95.592 133.03 96.232 133.318C96.8827 133.606 97.384 134.016 97.736 134.55C98.0987 135.072 98.2853 135.691 98.296 136.406H95.944C95.8907 135.936 95.688 135.552 95.336 135.254C94.9947 134.955 94.5307 134.806 93.944 134.806C93.432 134.806 93.0107 134.918 92.68 135.142C92.3493 135.355 92.184 135.675 92.184 136.102C92.184 136.326 92.2373 136.512 92.344 136.662C92.4507 136.811 92.616 136.939 92.84 137.046C93.0747 137.142 93.3627 137.227 93.704 137.302C94.0453 137.376 94.4507 137.462 94.92 137.558C95.4 137.643 95.8533 137.755 96.28 137.894C96.7173 138.022 97.1013 138.203 97.432 138.438C97.7733 138.662 98.04 138.96 98.232 139.334C98.424 139.707 98.52 140.176 98.52 140.742C98.52 141.435 98.3387 142.048 97.976 142.582C97.6133 143.115 97.1013 143.531 96.44 143.83C95.7893 144.128 95.0267 144.278 94.152 144.278ZM100.596 132.982H109.476V135.046H106.228V144.182H103.828V135.046H100.596V132.982ZM110.022 144.182L114.118 132.982H116.998L121.062 144.182H118.486L117.622 141.734H113.366L112.502 144.182H110.022ZM114.006 139.798H116.966L115.478 135.542L114.006 139.798ZM123.849 132.982H128.409C129.231 132.982 129.951 133.136 130.569 133.446C131.188 133.755 131.668 134.187 132.009 134.742C132.351 135.286 132.521 135.942 132.521 136.71C132.521 137.424 132.345 138.059 131.993 138.614C131.652 139.158 131.188 139.574 130.601 139.862L132.809 144.182H130.153L128.265 140.422H126.249V144.182H123.849V132.982ZM126.249 134.982V138.422H128.217C128.783 138.422 129.231 138.267 129.561 137.958C129.903 137.648 130.073 137.232 130.073 136.71C130.073 136.176 129.903 135.755 129.561 135.446C129.231 135.136 128.783 134.982 128.217 134.982H126.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112 75.8277L112 124.207H112.792L112.792 75.8277H112ZM112 154.345L112 182.897H112.792L112.792 154.345H112Z",
    fill: "url(#paint3_linear_347_7336)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_347_7336",
    x: 44,
    y: 44.2392,
    width: 136,
    height: 195.761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.7608
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.82057
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.0431373 0 0 0 0 0.0196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_347_7336"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_347_7336",
    x1: 112,
    y1: 56,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4495C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E1E27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_347_7336",
    x1: 112,
    y1: 74.6379,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4495C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_347_7336",
    x1: 112,
    y1: 154.345,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_347_7336",
    x1: 112.396,
    y1: 124.207,
    x2: 112.396,
    y2: 182.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProLevelOne);
export default __webpack_public_path__ + "static/media/pro-level-one.3ad9758cc2de4f754255d8278a01ded8.svg";
export { ForwardRef as ReactComponent };